import { FC } from 'react';

import { BoxProps, DotsHorizontalOutline, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Spacer, Text } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { DropdownOption } from '../common/dropdown';
import { ReactionSelect } from '../reactions/reaction-select';
import { ActionButton } from './action-button';
import { useBonusCardActions } from './hooks/use-bonus-card-actions';

export interface BonusCardActionsProps extends BoxProps {
	bonus: Bonus;
	onClickAddOn: VoidFunction;
	onClickComment: VoidFunction;
	onClickRequestFeedback: VoidFunction;
}

export const BonusCardActions: FC<BonusCardActionsProps> = ({ bonus, onClickAddOn, onClickComment, onClickRequestFeedback, ...rest }) => {
	const { actions, displayMenu, menuOptions } = useBonusCardActions({
		bonus,
		onClickAddOn,
		onClickComment,
		onClickRequestFeedback,
	});

	return (
		<Flex dir="row" {...rest}>
			<HStack spacing={2}>
				{actions.map((action, index) => (
					<ActionButton aria-label={action.label} color={action.color} icon={<action.icon />} key={index} onClick={action.action}>
						{action.text}
					</ActionButton>
				))}

				{displayMenu && (
					<Menu>
						<MenuButton
							as={IconButton}
							icon={<DotsHorizontalOutline />}
							bg="bg.surface"
							borderColor="border.soft"
							borderRadius="md"
							borderStyle="solid"
							borderWidth="1px"
							color="text.default"
							_hover={{
								bg: 'secondary.bgAlpha',
								borderColor: 'transparent',
							}}
						/>
						<MenuList border="none" p={1}>
							{menuOptions.map((action, index) => (
								<MenuItem as={DropdownOption} h={12} key={index} onClick={action.action}>
									<HStack>
										<action.icon />
										<Text>{action.text}</Text>
									</HStack>
								</MenuItem>
							))}
						</MenuList>
					</Menu>
				)}
			</HStack>

			<Spacer />

			<ReactionSelect bonus={bonus} />
		</Flex>
	);
};
